import Handlebars from 'handlebars';

const NS = 'WoolBtbInThisIssueBlock';
const CLS = 'woolBtbInThisIssueBlock';

export class WoolBtbInThisIssueBlock {
	constructor(element) {
		this.element = element;
		this.$el = $(element);

		this.$articles = this.$el.find(`.${CLS}-articles`);
		this.$carouselSlider = this.$el.find(`.${CLS}-slider`);
		this.$category = this.$el.find(`.${CLS}-category`);
		this.$categoryOnFarm = this.$el.find(`.${CLS}-control-onFarm`);
		this.$categoryOffFarm = this.$el.find(`.${CLS}-control-offFarm`);
		this.$emptyMessage = this.$el.find(`.${CLS}-empty`);

		this.sourceId = this.$el.data('sourceId');
		this.getArticlesApi = this.$el.data(`articlesApi`);
		this.getColourCode = this.$el.data(`colourCode`)
		this.isLoadingArticles = false;

		this.$categoryOnFarm.css({"background": this.getColourCode, "color": "#fff"});

		this.initParams();
		this.eventHandler();
		this.getArticles();
		this.check();
	}

	initParams(){
		this.params = {
			sourceId: this.sourceId,
			category: this.$categoryOnFarm.val()
		};
	}

	eventHandler() {

		this.$categoryOnFarm.on('click', () => {
			this.$carouselSlider.empty();
			this.$carouselSlider.removeClass("slick-initialized slick-slider slick-dotted");
			this.params.category = "ON-FARM";
			this.$category.css({"background": "#fff", "color": "#000"});
			this.$categoryOnFarm.css({"background": this.getColourCode, "color": "#fff"});
			this.getArticles();
		});
		this.$categoryOffFarm.on('click', () => {
			this.$carouselSlider.empty();
			this.$carouselSlider.removeClass("slick-initialized slick-slider slick-dotted");
			this.params.category = "OFF-FARM";
			this.$category.css({"background": "#fff", "color": "#000"});
			this.$categoryOffFarm.css({"background": this.getColourCode, "color": "#fff"});
			this.getArticles();
		});
	}
	
	getArticleCardBlockTemplate() {
		let articleCardBlock = require('../../woolBtbInThisIssueCardBlock/tmpl/woolBtbInThisIssueCardBlock.hbs');
		Handlebars.registerPartial('woolBtbInThisIssueCardBlock', articleCardBlock);

		let template = `
			{{> woolBtbInThisIssueCardBlock
				blk="woolBtbInThisIssueCardBlock"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		return Handlebars.template(precompiled);
	}

	check(){
		let onFarmHasArticle;
		let offFarmHasArticle;
		let urlOnFarm = `${this.getArticlesApi}?category=ON-FARM&pageID=${this.params.sourceId}`;
		let urlOffFarm = `${this.getArticlesApi}?category=OFF-FARM&pageID=${this.params.sourceId}`;
		//let urlOnFarm = `https://run.mocky.io/v3/74a910a7-9ed5-4e05-b841-0181994ea31b`;
		//let urlOffFarm = `https://run.mocky.io/v3/74a910a7-9ed5-4e05-b841-0181994ea31b`;
		$.ajax({
			type: 'GET',
			url: urlOnFarm,
			success: (data) => {
				if(data.results.length == 0){
					onFarmHasArticle = 0;
					this.$categoryOnFarm.css("display","none");
					this.$categoryOffFarm.css({"background": this.getColourCode, "color": "#fff"});
				}
			},
			error: (res, error) => {
				console.log("error loading articles", error);
			},
			complete: () => {
				$.ajax({
					type: 'GET',
					url: urlOffFarm,
					success: (data) => {
						if(data.results.length == 0){
							offFarmHasArticle = 0;
							this.$categoryOffFarm.css("display","none");
						}
					},
					error: (res, error) => {
						console.log("error loading articles", error);
					},
					complete: () => {
						if(offFarmHasArticle == 0 && onFarmHasArticle == 0){
							$('.woolBtbInThisIssueBlock').css("display","none");
						};
					},
				});
			}
		});
	}

	getArticles() {

		let url = `${this.getArticlesApi}?category=${this.params.category}&pageID=${this.params.sourceId}`;

		this.isLoadingArticles = true;

		$.ajax({
			type: 'GET',
			url: url,
			success: (data) => {
				this.isLoadingArticles = false;
					data.results.forEach((item) => {
						item["blk"] = "woolBtbInThisIssueCardBlock";
						this.$carouselSlider.append(this.getArticleCardBlockTemplate()(item));
					});
					this.$carouselSlider.slick({
						dots: true,
						dotsClass: `slick-dots`,
						slidesToShow: 2,
						autoplay: false,
						autoplaySpeed: 5000,
						slidesToScroll: 2,
						rows: 2,
						nextArrow: `<button type="button" class="slick-arrow slick-arrow--next"><i class="slick-arrow-icon icon icon--chevron-lg-right"></i></button>`,
						prevArrow: `<button type="button" class="slick-arrow slick-arrow--previous"><i class="slick-arrow-icon icon icon--chevron-lg-left"></i></button>`,
						infinite: false,
						responsive: [
							{
							breakpoint: 768,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								rows: 2,
							}
							}
						]
					});
					$(".woolBtbInThisIssueCardBlock-title").css("color", this.getColourCode);
			},
			error: (res, error) => {
				console.log("error loading articles", error);
			},
			complete: () => {
				this.isLoadingArticles = false;
			},
		});	
		
	}
}
